<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Adicionar Post</div>
                <div class="description">Adcione as informações do post</div>
            </header>
            <fluke-blog-form
                :permission="permission"
                :categories="categories"
                @cancel="cancel"
                @submit="submit"
            ></fluke-blog-form>
        </fluke-card>
    </div>
</template>

<script>
import axios from "axios";
import Card from "../../components/Main/Content/Card/Card.vue";
import Button from "../../components/Main/Content/Button/Button.vue";
import Form from "./Form";
import permission from "../../mixins/permissions";
import { postCreateValidator } from "../../helpers/post_validator";

export default {
    mixins: [permission],
    components: {
        "fluke-card": Card,
        "fluke-button": Button,
        "fluke-blog-form": Form
    },
    data: function() {
        return {
            categories: [],
            permission: {
                read: false,
                write: false
            }
        };
    },
    created: function() {
        this.permission = this.getUserPagePermission("blog");
        if (this.permission.read == false || this.permission.write == false) {
            this.$router.push("/");
        }
        this.loadData();
    },
    methods: {
        loadData: async function() {
            axios
                .get(this.$myServerAddresses.blog + "categories", {
                    headers: {
                        "X-Fluke": this.$cookies.get("token")
                    }
                })
                .then(result => {
                    this.categories = result.data;
                });
        },
        submit: async function(data) {
            if (
                data.post.includes('src="data:image/') ||
                data.post.includes("src='data:image/")
            ) {
                alert(
                    "Não colar imagem direto no post, por favor utilize o upload de imagem do editor"
                );
                return;
            }
            try {
                await postCreateValidator(data);
                await axios.post(this.$myServerAddresses.blog + "posts", data, {
                    headers: {
                        "X-Fluke": this.$cookies.get("token")
                    }
                });
                this.$router.push({ name: "blog" });
            } catch (error) {
                this.$store.commit("flash_error", error.message);
            }
        },
        cancel: function() {
            this.$router.push({ name: "blog" });
        }
    }
};
</script>
